var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#7D86A1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5L0 4.5M4.5 9L0 4.5 4.5 0",
    transform: "rotate(-90 15.5 4.5)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#7D86A1",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M7 20a4 4 0 004 4h9a4 4 0 004-4h0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadIcon.ad8d5ddb.svg";
export { ForwardRef as ReactComponent };